import InputPage from "./InputPage";

export default InputPage;
